/**
 * @time 2024/05/30
 * @author 邻家大龙猫
 * @description 中文语言配置文件
 * */

import system from './system'
import homePage from "./homePage"
import aboutPage from "./aboutPage"
import applicationAreaPage from "./applicationAreaPage"
import productPage from './productPage'
import newsPage from './newsPage'
import joinInPage from './joinInPage'
import productCenterPage from './productCenterPage'
import productProgramPage from './productProgramPage'
import customerServicePage from './customerServicePage'
import contactUs from './contactUs'
import messageRecord from './messageRecord'
import footer from './footer'
import search from './search'


const cn = {
  prefix: '',
  value: 'zh-CN',
  label: '简体中文',
  config: {
    navbar: {
      home: '首页',
      about: '关于 KELK',
      applicationArea: '应用领域',
      production: '产品资源',
      news: '新闻',
      joinIn: '招聘',
      searchPlaceholder: '请输入关键字',
      searchType: [
        { value: 'product', label: '产品', path: '/prod_search_list' },
        { value: 'plan', label: '文章', path: '/search' },
      ]
    },

    subNavbar: {
      productCenter: '产品中心',
      productProgram: '产品方案',
      customerService: '客户服务',
      contactUs: '联系我们',
    },
    system,
    footer,
    // 首页
    homePage: homePage,
    // 关于页面
    aboutPage: aboutPage,
    // 应用领域页面
    applicationAreaPage: applicationAreaPage,
    // 产品应用
    productApplication: {
      title: '产品应用',
    },
    // 产品资源
    productPage,
    // 资讯页面
    newsPage,
    // 加盟页面
    joinInPage,
    // 产品中心
    productCenterPage,
    // 产品方案
    productProgramPage,
    // 客户服务
    customerServicePage,
    // 联系我们
    contactUs,
    messageRecord,
    // 搜索页面相关
    search,
  }
}



export default cn


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/index.js